import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/processTemplate/getters";
import { actions } from "@/store/modules/processTemplate/actions";
import { mutations } from "@/store/modules/processTemplate/mutations";
import {
  IProcessTemplateState,
  state,
} from "@/store/modules/processTemplate/state";

export const processTemplate: Module<IProcessTemplateState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
